<template>
  <el-tooltip :content="tooltipView" placement="bottom" :open-delay="500">
    <v-btn :icon="type === 'icon'" :text="type === 'text'" :to="backTo">
      <slot>
        <v-icon>mdi-arrow-left</v-icon>
      </slot>
    </v-btn>
  </el-tooltip>
</template>

<script>
import {safeMeta} from "@/router/Meta";

export default {
  name: 'BackButton',
  props: {
    to: {
      type: [String, Object],
      required: false
    },
    tooltip: {
      type: String,
      required: false
    },
    type: {
      type: String,
      default: 'icon'
    },
  },
  computed: {
    backTo() {
      if(this.to) {
        return this.to;
      } else {
        return {name: safeMeta(this.$route).parent};
      }
    },
    tooltipView() {
      if(this.tooltip) {
        return this.tooltip
      } else {
        const {route: parent} = this.$router.resolve(this.backTo);
        return `${safeMeta(parent).label}に戻る`;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
// 必ずアクティブになってしまうので見た目だけでも非アクティブ化
.v-btn--active:before {
  opacity: 0 !important;
}
</style>
